import { ItemSortOption } from '@rematter/frontend-lib-api-client';

import { ItemRecord } from '../types/inventoryItem';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const itemsListQueryAtom = createQueryAtomFactory(
  'settings.itemsList',
  (params: {
    ids?: string[];
    searchTerm?: string;
    categoryId?: string;
    itemGroupId?: string;
    limit?: number;
    offset?: number;
    sorting?: ItemSortOption[];
  }) => ({
    items: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          categoryId: params.categoryId,
          itemGroupId: params.itemGroupId,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        skuNumber: true,
        description: true,
        notes: true,
        category: {
          id: true,
          name: true,
        },
        itemGroup: {
          id: true,
          name: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { items: ItemRecord[]; totalCount: number } => {
      if (!data?.items?.entries) {
        return { items: [], totalCount: 0 };
      }

      return {
        items: data.items.entries.map((item) => ({
          id: item.id,
          name: item.name,
          skuNumber: item.skuNumber,
          description: item.description ?? '',
          notes: item.notes ?? '',
          category: item.category
            ? {
                id: item.category.id,
                name: item.category.name,
              }
            : null,
          itemGroup: item.itemGroup
            ? {
                id: item.itemGroup.id,
                name: item.itemGroup.name,
              }
            : null,
          timestamps: {
            createdAt: parseZonedDateTime(item.timestamps.createdAt),
            updatedAt: parseZonedDateTime(item.timestamps.updatedAt),
          },
        })),
        totalCount: data.items.page?.total ?? 0,
      };
    },
  },
);
